import React, { Suspense} from 'react';

import PrivateRoute from 'components/auth/PrivateRoute';
import LoadingScreen from 'components/common/LoadingScreen';
import Login from 'pages/auth/login';
import Error404 from 'pages/error/error404';
import {useQueryClient} from 'react-query';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';

import {AUTH_USER_INFO_KEY} from '../constants/QueryKey';
import {BookingScreen} from './Lazy';

const RouteContainer = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const user = queryClient.getQueryData(AUTH_USER_INFO_KEY);

  return (
    <>
      <Suspense fallback={ <LoadingScreen /> }>
        <Switch>
          {/*Main routers*/}
          <Route exact path="/error/404" component={ Error404 } />
          <Route exact path="/:pathParam/login">
            { user ? user.meta.status_code === 0 ?  <Redirect to={ { pathname: '/', state: { from: location } } } /> : <Login /> : <Login /> }
          </Route>
          <PrivateRoute exact path="/:pathParam" component={ BookingScreen } />

          {/*Redirect*/}
          <Redirect to="/error/404" />

        </Switch>
      </Suspense>
    </>
  );
};

export default RouteContainer;